import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'app-calendar-timestamp',
  templateUrl: './calendar-timestamp.component.html'
})
export class CalendarTimestampComponent implements OnInit {
  @Input() formName: string;
  @Input() form: FormGroup;
  @Input() required: boolean;
  @Input() showTime: boolean;
  @Output() selecteddate = new EventEmitter();
  se;

  constructor() { }

  ngOnInit() {
    this.se = {
      firstDayOfWeek: 1,
      dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
      dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
      dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
      monthNames: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
      today: 'I dag',
      clear: 'Rensa',
      dateFormat: 'yy-mm-dd HH:mm',
      weekHeader: 'Vecka'
    };
  }

  changedDate(evt) {
    this.form.patchValue({
      [this.formName]: moment(evt).format('YYYY-MM-DD HH:mm')
    });
  }

}
